import React from 'react';
// @ts-expect-error checkout/react-components
import { LoadingElement } from '@checkout/react-components';
// @ts-expect-error type-lazyLoader
import { getLazyLoaderRenderFunction, lazyLoader } from '@/lib';

export const LazyMemberOTPInterstitial = lazyLoader({
  loader: () => import('./MemberOTPInterstitial'),
  loading: () => <LoadingElement />,
  name: 'member_otp',
  render: getLazyLoaderRenderFunction({
    componentName: 'MemberOTPInterstitial',
  }),
});
